<template>
  <v-main class="page-suitcase page-suitcase-main">
    <v-container fluid>

      <div class="page-suitcase-top">
        <v-spacer/>
        <v-btn rounded small depressed
               :color="isSamsungFire ? 'primary' : ''"
               :text="!isSamsungFire"
               class="btn-suitcase-info"
               @click="next('/fo/suitcase/TIC')">
          <i class="icon-info"></i>여행 안내소
        </v-btn>
      </div>

      <div class="my-info">
        <v-img :src="profile" class="my-info-avatar"/>

        <v-btn text x-large
               class="btn-edit-my-info"
               :to="isSamsungFire ? '/fo/nickname' : '/fo/myInfo'">
          <div class="text-ellipsis">{{ nickname }}</div>
        </v-btn>

        <div class="my-info-buttons">
          <v-btn rounded small depressed
                 :color="isSamsungFire ? 'gray-100' : ''"
                 :text="!isSamsungFire"
                 class="btn-suitcase-my-ticket"
                 @click="goMyticket">
            <i></i>내 티켓
          </v-btn>
          <v-btn v-if="!isSamsungFire"
                 rounded small depressed text
                 class="btn-suitcase-my-coin"
                 @click="goCoinPage">
            <i></i>{{ amountCoin | comma }}
          </v-btn>
        </div>
      </div>
      <!-- 여행이 있을경우 -->
      <div v-if="travelYn === 'Y' || travelStopYn === 'Y'" class="my-travelling-box">
        <div class="my-travelling-info">
          <v-img v-if="!isSamsungFire" :src="getImage('background/space/thumb_ezn.jpg')" class="my-travelling-img" />
          <p class="text">
            <template v-if="travelStopYn === 'N' && !isPauseReserved">
              <b>{{ ongoingTravelDaysText }}</b><br/>
              <span v-if="isSamsungFire">집중관리 | </span>{{ usagePeriodYmd }}
            </template>
            <template v-else-if="isPauseReserved">
              <b @click="solutionPause()">{{ usePeriodDays }}일째 여행중 (일시중지 예정: {{ useOrdDtl.useStopStartDtSt }}~)</b>
              {{ usagePeriodYmd }}
            </template>
            <template v-else>
              <b @click="solutionPause()">(중지기간 : {{useOrdDtl.useStopStartDtSt}} ~ {{useOrdDtl.useStopEndDtSt}})</b><br/>
              {{ ongoingTravelDays }}일째 이용 중, 잠시 쉬고 있어요
            </template>
          </p>
        </div>
      </div>

      <!-- 진행중 여행이 없을경우-->
      <div v-else-if="travelYn === 'N'" class="my-travelling-box no-travel">
        <div class="my-travelling-info travel-empty">
          <p class="text"><b>현재 진행중인 여행이 없습니다.</b></p>
        </div>
        <div class="text-center">
          <v-btn v-if="ticketList.length === 0"
                 depressed rounded
                 color="primary"
                 class="btn-start"
                 @click="goByTicket('Y')">
            <template v-if="isSamsungFire || memberGb === '01'">내 티켓 보러가기</template>
            <template v-else>티켓 구매하러가기</template>
          </v-btn>
          <v-btn v-else-if="ticketList.length !== 0"
                 depressed rounded
                 color="primary"
                 class="btn-start"
                 @click="goByTicket('Y')">내 티켓
            보러가기
          </v-btn>
        </div>
      </div>
      <br>
      <p class="text-center" v-if="isSamsungFire && validperiodEndDt !== ''">
        <v-chip small color="primaryLight" text-color="primary" class="py-2">
          서비스 이용기간
          <v-divider vertical class="mx-2" />
          <b>{{ validperiodStartDt }} ~ {{ validperiodEndDt }}</b>
        </v-chip>
      </p>

      <!-- 나의 마음나무 -->
      <article class="page-suitcase-box">
        <header class="box-header">
          <h2 class="box-title">나의 마음나무</h2>
        </header>
<!--        v-if="!(solMappingYn === 'success' || travelYn === 'Y' || noGuide === true)"-->
        <div v-if="isBeforeApplResultYn || travelYn === 'Y' || noGuide === true" class="my-tree-box">
          <div class="my-tree-info">
            <img v-if="weatherUrl !== ''" :src="getImage(weatherUrl)" height="52" class="ml-22">
            <img v-if="treeUrl !== ''" :src="getImage(treeUrl)" height="136">
          </div>
          <v-btn depressed rounded
                 color="primary"
                 class="btn-start"
                 @click="goTravelPageMyTree('S')">검사 결과 보기</v-btn>
        </div>
        <div v-else class="my-tree-box">
          <div class="my-tree-info tree-empty">
            <v-img v-if="isSamsungFire" contain height="110px" :src="getImage('tree/ic_no_tree.svg')"/>
            <p class="text">현재 마음나무가 없습니다.</p>
          </div>
          <v-btn depressed rounded
                 color="primary"
                 class="btn-start"
                 @click="getMemberStepCnt">여행지원서 작성하러가기</v-btn>
        </div>
      </article>
      <!-- // 나의 마음나무 -->

      <!-- 내 뱃지 -->
      <article class="page-suitcase-box">
        <header class="box-header">
          <h2 class="box-title">내 뱃지</h2>
          <v-btn text :ripple="false" depressed
                 class="btn-allView"
                 @click="next('/fo/myBadge')">
            자세히 보기
          </v-btn>
        </header>
        <ul class="badge-list">
          <li class="badge-list-item" v-for="(item, index) in badgeArr" :key="index">
            <Badge :info="item"/>
          </li>
        </ul>
      </article>
      <!-- // 내 뱃지 -->

      <article class="page-suitcase-box">
        <header class="box-header">
          <h2 class="box-title">마음 날씨</h2>
        </header>
        <v-btn-toggle v-model="mindWeather"
                      group dense color="primary"
                      class="toggle-category-group">
          <v-btn v-for="(item, index) in mindWeatherArr" :key="index"
                 depressed outlined :ripple="false"
                 active-class="active"
          >{{ item }}</v-btn>
        </v-btn-toggle>
        <div :style="mindWeather == 0? 'display:block' : 'display:none'">
          <LineChart :height="170" :week="week" :scoreArr="scoreArr[0]"/>
        </div>
        <div :style="mindWeather == 1? 'display:block' : 'display:none'">
          <LineChart :height="170" :week="week" :scoreArr="scoreArr[1]"/>
        </div>
        <div :style="mindWeather == 2? 'display:block' : 'display:none'">
          <LineChart :height="170" :week="week" :scoreArr="scoreArr[2]"/>
        </div>
        <div class="text-center mt-8">
          <v-btn depressed rounded
                 color="primary"
                 class="btn-start"
                 @click="next('/fo/suitcase/mindWeather')">더보기
          </v-btn>
        </div>
      </article>

      <article class="mt-8">
        <ul class="list-group">
          <li>
            <router-link to="/fo/suitcase/mindNote">마음노트</router-link>
          </li>
          <li>
            <router-link to="/fo/library/interest/">관심 콘텐츠</router-link>
          </li>
          <li v-if="memberGb !== '01'">
            <router-link to="/fo/purchase/history">구매내역</router-link>
          </li>
          <li v-if="memberGb !== '01'">
            <router-link to="/fo/purchase/myCoupon">내 쿠폰 정보</router-link>
          </li>
        </ul>
      </article>

      <BottomMenu :current="4"/>
      <Modal :dialog="dialog" :str="modalText" @close="modalClose"/>
      <!-- <ModalConfirm :dialog="dialog" :str="modalText" :btn1="{str:'취소',event: 'close'}" :btn2="{str:'작성하기',event: 'delete', color:'#FF4A4A'}" @close="modalClose" @delete="newTravelIntro"/> -->
      <ModalConfirm :dialog="confirmdialog" :str="confirmmodalText"
                    :btn1="{str:btnStr1,event: btnEvent1}" :btn2="{str:btnStr2,event: btnEvent2, color:'#FF4A4A'}"
                    :isClose="isClose" @confirmClose="confirmmodalClose"
                    @close="confirmmodalClose" @delete="newTravelIntro" @newTravel="setMemberResultDel"
                    @startTravel="goTravelPage('S')" @cancel="cancel"/>
    </v-container>
  </v-main>
</template>
<script>
import store from '@/store'
import {mixinRemote, mixinAuth, mixinTravel, mixinTicket, mixinTrial} from '@/mixins'
import Badge from '@/components/icons/Badge'
import BottomMenu from '@/components/layout/BottomMenu'
import LineChart from '@/components/chart/LineChart'
import Modal from '@/components/layout/modal/Modal'
import ModalConfirm from '@/components/layout/modal/ModalConfirm'
import Util from "@/utils/utils";

export default {
  components: {
    Badge,
    BottomMenu,
    LineChart,
    ModalConfirm,
    Modal
  },
  mixins: [mixinRemote, mixinAuth, mixinTravel, mixinTicket, mixinTrial],
  data: () => ({
    mindWeather: 0,
    mindWeatherArr: ['마음 날씨', '몸 날씨', '기분 날씨'],
    dialog: false,
    modalText: '',
    // memberNo: 0,
    weatherUrl: '',
    treeUrl: '',
    goTravelApplStepCd: '0001',
    badgeArr: [],
    emptyBadgeImg: 'badge/ic_no_badge.svg',
    // 마음날씨 start
    weekYn: 'Y',
    today: '',
    startDt: '',
    endDt: '',
    week: [],
    scoreArr: [[], [], []],
    // score:[],
    // 마음날씨 end
    confirmdialog: false,
    confirmmodalText: '',
    usePsbYn: '',
    remainCnt: 0,
    travelApplNo: 1,
    travelApplStepCd: '0001',
    memberStepApplCnt: 0,
    btnStr1: '',
    btnStr2: '',
    btnEvent1: '',
    btnEvent2: '',
    btnGubun: 0,
    ticketList: [],
    // clientCd: '',
    // nickname:'',
    isClose: false,
    noGuide: false,
    amountCoin: 0,
    validperiodStartDt: '',
    validperiodEndDt: '',
    weatherStatus: null
  }),
  computed: {
    ongoingTravelDaysText () {
      let ongoingTravelDays  = `${this.ongoingTravelDays }일째 여행중`;
      if (this.hasActiveTrial && this.expiredTrial) ongoingTravelDays  += ' (체험기간종료)'
      return ongoingTravelDays
    },
    usagePeriodYmd () {
      if (this.hasActiveTrial) {
        const strDt = Util.Date.toFormatDate(this.trialActiveDateTime, 'YYYY.MM.DD')
        const endDt = Util.Date.toFormatDate(this.trialInactiveDateTime, 'YYYY.MM.DD')
        if (this.expiredTrial) return `${strDt} ~`
        return `${strDt} ~ ${endDt}`
      }
      else {
        return `${this.usePeriodStartDtSt} ~ ${this.usePeriodEndDtSt}`
      }
    },
    ongoingTravelDays () {
      if (this.hasActiveTrial && this.expiredTrial) return this.trialDays
      return this.usePeriodDays
    },
    profile() {
      // let avatar = this.avatarImages.filter(a => a.key === store.getters.profileAtchNo)
      // if (avatar.length) return avatar[0].url
      // else return this.avatarImages[0].url

      let avatar = null
      if(store.getters.profileAtchNo == null || store.getters.profileAtchNo < 1){

        if(this.isSamsungFire){
          avatar = this.avatarImages.filter(a => a.key === store.getters.profileAtchNo)
          if (avatar.length) return avatar[0].url
          else return this.avatarImages[0].url

        } else{

          return require('@/assets/images/bi/bi_img.png')
        }
      } else{

        if (this.isSamsungFire) { // 삼성화재

          avatar = this.avatarImages.filter(a => a.key === store.getters.profileAtchNo)
          if (avatar.length) return avatar[0].url
          else return this.avatarImages[0].url

        }else{
          avatar = store.getters.profileAtchFileName
          return this.$downUrl(avatar)
        }
      }
    },
    travelStop() {
      if(this.travelStopYn === 'Y'){
        return '(중지 중)'
      }
      return ''
    },
    isPauseReserved () {
      if (this.isSamsungFire) return false
      const stopStartDate = this.useOrdDtl.useStopStartDt
      return (stopStartDate && Util.Date.isBefore(stopStartDate))
    }
  },
  watch: {
    mindWeather() {
      // console.log("mindWeather : ", this.mindWeather)
    },
    today() {
      this.getWeekData()
    },
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  created() {
    // this.memberNo = store.getters.userKey
    // this.clientCd = store.getters.clientCd
  },
  async mounted() {
    // 가장 최근의 여행지원서 결과 (사전검사) 여부 조회
    this.getBeforeAppResultList();
    //솔루션 매핑여부 확인
    this.getMappingSolution();
    this.getCoinAmount();
    this.getMemberApplResultLast();
    this.getMemberRewardBadge();
    this.getToday() // 오늘 날짜 구함
    await store.dispatch('getUseOrdDtl')
    if (this.isSamsungFire) {
      //유저 삼성 티켓 리스트 API
      this.getFireTicketList()
      this.getFireTicketCheck()
    } else {
      //유저 티켓 리스트 API
      this.getTicketList()
    }
    // this.getUserNickname();
    //티켓 선택 후 가이드 및 찐한대화 일정 미입력 여부
    this.getUseOrdDtlNoGuide()
  },
  methods: {
    next(url) {
      this.movePage(url);
    },
    modalClose() {
      this.dialog = false;
    },
    confirmmodalClose() {
      this.confirmdialog = false;
      //this.movePage('/user');
    },
    // newTravelIntro(){
    //     this.$router.push({ name: "travelIntro", params: { travelApplStepCd: this.goTravelApplStepCd, startType: 'R' } });
    // },
    // goTravelPage() {
    //     this.$router.push({ name: "travelIntro", params: { travelApplStepCd: this.goTravelApplStepCd, startType: 'S' } });
    // },
    goTravelPage(type) {
      // travelApplStepCd = 사전검사(0001), 중간검사(0002), 사후검사(0003)
      // startType = 단계별 처음(S), 단계별 다시시작(R)
      // 단계별 다시시작은 각 검사 단계의 결과까지 보았으나 다시 검사를 하는 경우 사용한다.
      this.$router.push({
        name: "travelIntro",
        query: {travelApplStepCd: this.travelApplStepCd, startType: type, isSuitcase: true}
      });
    },
    goTravelPageMyTree(type) {
      // travelApplStepCd = 사전검사(0001), 중간검사(0002), 사후검사(0003)
      // startType = 단계별 처음(S), 단계별 다시시작(R)
      // 단계별 다시시작은 각 검사 단계의 결과까지 보았으나 다시 검사를 하는 경우 사용한다.
      this.$router.push({
        name: "travelIntro",
        query: {travelApplStepCd: this.travelApplStepCd, startType: type, isSuitcase: true, isMyTree: true}
      });
    },
    ticketStart(checkYn) {
      if (this.isSamsungFire && checkYn === 'Y') {
        //여행 시작하기 전 다시체크
        this.getFireTicketCheck('Y')
      } else {
        if (this.noGuide === false) {
          if (this.ticketList.length === 0 && this.memberGb === '02') {
            //티켓 사용
            this.movePage('/fo/TicketSelectEzn');
          } else {
            //티켓 사용
            this.movePage('/fo/myTicket');
          }
        } else {
          //TODO.
          if (!store.state.client.contract.allowsRealtalkService) {
            //가이드 선택
            this.movePage('/fo/myTicket');
          } else {
            this.movePage('/fo/guideSelect');
          }
        }
      }

      //TODO EZN 개발진행 시 재결제 변경,유지 모달창 추가예정
      //this.movePage('/user/fo/guideSelect');
    },
    goMyticket() {
      if (this.noGuide === false) {
        //티켓 사용
        this.movePage('/fo/myTicket');
      } else {
        //가이드 선택
        this.movePage('/fo/guideSelect');
      }
    },
    ticketCheck(useYn) {
      if (this.usePsbYn === 'N') { //유효기간 D-85일 이하 이면 사용 불가 가용가능(Y), 불가능(N)
        // this.modalText = '집중관리(상담) 티켓은 서비스 종료 전</br> 3개월까지만 발급 가능합니다.</br> 기업체 담당자에게 문의해주세요.'
        // this.dialog = true
        this.$alert('집중관리(상담) 티켓은 서비스 종료 전</br> 3개월까지만 발급 가능합니다.</br> 기업체 담당자에게 문의해주세요.')
      } else if (this.weatherStatus.stateCd == '01') {
        // this.modalText = "마음날씨가 '쨍쨍/맑음'인 경우,</br> 집중관리(상담)가 진행되지 않습니다.</br> 집중관리(상담)가 필요한 경우가 생기면,</br> 다시 여행 지원서를 작성해 보세요."
        // this.dialog = true
        this.$alert("마음날씨가 '쨍쨍'인 경우,</br> 집중관리(상담)가 진행되지 않습니다.</br> 집중관리(상담)가 필요한 경우가 생기면,</br> 다시 여행 지원서를 작성해 보세요.")
      } else if (this.remainCnt <= 0) {
        // this.modalText = '집중관리(상담) 받을 수 있는</br> 기회가 선착순으로 마감되었습니다.</br> 기업체 담당자에게 문의해 주세요.'
        // this.dialog = true
        this.$alert('집중관리(상담) 받을 수 있는</br> 기회가 선착순으로 마감되었습니다.</br> 기업체 담당자에게 문의해 주세요.')
      } else {
        if (useYn === 'Y') {
          //티켓 사용
          //this.insertUserTicket(this.ticketList[this.current-1])
          //this.movePage('/user/fo/myTicket');
          // if(this.ticketList.length == 0){
          //     this.movePage('/user/fo/ticketSelect');
          // } else {
          //     this.movePage('/user/fo/myTicket');
          // }
          if (this.noGuide === false) {
            //티켓 사용
            this.movePage('/fo/myTicket');
          } else {
            //가이드 선택
            this.movePage('/fo/guideSelect');
          }
        }
      }

    },
    setConfirmMessage1() {
      this.confirmdialog = false;
      this.confirmmodalText = "작성 중인 여행지원서가 있습니다. <br>이어서 하시겠습니까?";
      this.btnStr1 = "새로 작성하기";
      this.btnStr2 = "이어서 하기";
      this.btnEvent1 = 'cancel';
      this.btnEvent2 = 'startTravel';
      this.btnGubun = 1;
      this.isClose = false;
      this.confirmdialog = true;
    },
    setConfirmMessage2() {
      this.confirmdialog = false;
      this.confirmmodalText = "여행지원서를 새로 작성하시면 <br>전에 진행한 여행지원서는 삭제됩니다.";
      this.btnStr1 = "취소";
      this.btnStr2 = "새로 작성하기";
      this.btnEvent1 = 'cancel';
      this.btnEvent2 = 'newTravel';
      this.btnGubun = 2;
      this.isClose = false;
      this.confirmdialog = true;
    },
    setConfirmMessage3() {
      this.$confirm('현재 완료한 여행지원서가 없습니다.<br/>먼저 여행지원서를 작성해주세요.', {
        persistent: false,
        showClose: false,
        actions: {
          false: {text: '취소'},
          true: {text: '작성하기'}
        }
      }).then(result => {
        if(result){
          this.newTravelIntro()
        }
      })

      // this.confirmdialog = false;
      // this.confirmmodalText = "현재 완료한 여행지원서가 없습니다.<br/>먼저 여행지원서를 작성해주세요.";
      // this.btnStr1 = "취소";
      // this.btnStr2 = "작성하기";
      // this.btnEvent1 = 'close';
      // this.btnEvent2 = 'delete';
      // this.btnGubun = 2;
      // this.isClose = false;
      // this.confirmdialog = true;
    },
    cancel() {
      this.confirmdialog = false;
      if (this.btnGubun === 1) {
        this.setConfirmMessage2();
      }
      // else {
      //     this.setConfirmMessage1();
      // }
    },
    newTravelIntro() {
      this.getMemberStepCnt()
      //this.$router.push({ name: "travelIntro", params: { travelApplStepCd: this.goTravelApplStepCd, startType: 'S' } });
    },
    async getFireTicketCheck(useYn) {  // 유저 삼성 티켓 체크 API
      await store.dispatch('getFireTicketCheck')
          .then(res => {
            if (res.success) {
              this.usePsbYn = res.data.usePsbYn
              this.remainCnt = res.data.remainCnt
              this.validperiodStartDt = res.data.validperiodStartDt
              this.validperiodEndDt = res.data.validperiodEndDt
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
            this.usePsbYn = 'N'
            this.remainCnt = 0
          })
          .finally(() => {
            if (useYn === 'Y') {
              this.ticketCheck(useYn)
            }
          })
    },
    async goByTicket(checkYn) { // 여행지원서 완료여부 확인
      await store.dispatch('getMemberApplResultCnt', this.$_payload('so', [
        {'travelApplNo': 1},
        {'memberNo': this.userKey},
        {'travelApplStepCd': ''}
      ]))
          .then(res => {
            if (res.success) {
              if (res.data === 0) {
                //this.modalText = "현재 완료한 여행지원서가 없습니다. 먼저 여행지원서를 작성해주세요.";
                //this.dialog = true;
                this.setConfirmMessage3()
              } else {
                //this.$router.push({ name: "travelIntro", params: { travelApplStepCd: "0001", startType: 'S' } });
                if(this.isBeforeApplResultYn || store.getters.useOrdDtl.travelYn === 'Y' || this.noGuide === true){
                  this.ticketStart(checkYn)
                } else {
                  this.setConfirmMessage3()
                }

              }
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    },
    async getMemberApplResultLast() { // 여행지원서 마지막 결과 확인
      await store.dispatch('getMemberApplResultLast', this.$_payload('so', [{'travelApplNo': 1}]))
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                store.commit('setApplResultSuccess')
                this.goTravelApplStepCd = res.data.travelApplStepCd;
                //this.travelApplStepCd = res.data.travelApplStepCd;
                this.getApplResultForWeatherStatus(res.data);
                this.getApplResultForTreeTotal(res.data);
              } else {
                store.commit('setApplResultFail')
              }
            } else {
              store.commit('setApplResultSuccess')
            }
          })
          .catch(() => {
            store.commit('setApplResultFail')
          })
          .finally(() => {
            store.commit('setInitApplResult', false)
          })
    },
    async getApplResultForWeatherStatus(so) {  // 여행지원서 마음날씨 구분 값 조회 Api
      await store.dispatch('getApplResultForWeatherStatus', this.$_payload('so', [
        {'travelApplNo': so.travelApplNo},
        {'unitNo': so.unitNo},
        {'travelApplStepCd': so.travelApplStepCd},
        {'memberStepApplCnt': so.memberStepApplCnt},
        {'memberNo': so.userKey},
        {'areaCritType': '01'},
        {'areaCrit': '00'},
      ]))
          .then(res => {
            if (res.success) {
              this.weatherUrl = res.data.imgPath;
              this.weatherStatus = res.data
            } else {
              console.log(res.msg)
              this.weatherStatus = null
            }
          })
          .catch(error => {
            console.error(error)
            this.weatherStatus = null
          })
          .finally(() => {
          })
    },
    async getApplResultForTreeTotal(so) {  // 여행지원서 마음나무 결과 조회 Api
      let params = [
        {'travelApplNo': so.travelApplNo},
        {'unitNo': so.unitNo},
        {'travelApplStepCd': so.travelApplStepCd},
        {'memberStepApplCnt': so.memberStepApplCnt},
        {'memberNo': so.userKey}
      ]
      await store.dispatch('getApplResultForTreeTotal', this.$_payload('so', params))
          .then(res => {
            if (res.success) {
              this.treeUrl = res.data.imgPath;
            } else {
              console.log(res.msg)
              this.treeEmotion = [];
            }
          })
          .catch(error => {
            console.error(error)
            this.treeEmotion = [];
          })
          .finally(() => {
          })
    },
    async getMemberRewardBadge() { // 내 뱃지
      await store.dispatch('getMemberBadge', this.$_payload({'userKey': this.userKey}))
          .then(res => {
            if (res.success) {
              for (var i = 0; i < 3; i++) {
                // this.badgeArr.push(res.data[i].userKey == null ? this.emptyBadgeImg : res.data[i].imgPath);
                // ezn nobadge 이미지가 구분 되어 있어 수정함
                this.badgeArr.push(res.data[i]);
              }
            } else {
              console.log(res.msg);
              this.badgeArr = [];
            }
          })
          .catch(error => {
            console.error(error);
            this.badgeArr = [];
          })
          .finally(() => {
          })
    },
    getToday() {
      const moment = require('moment')
      const today = moment()
      this.today = today
    },
    getWeekData() {
      const moment = require('moment')
      // 주차 시작/종료일 구하기
      const firstDay = moment(this.today).startOf("month").format('YYYYMMDD')
      const lastDay = moment(this.today).endOf("month").format('YYYYMMDD')
      const startDt = moment(this.today).day(0).format('YYYYMMDD')
      const endDt = moment(this.today).day(6).format('YYYYMMDD')

      // 주차 시작일
      if (startDt < firstDay) {
        this.startDt = firstDay
      } else {
        this.startDt = startDt
      }
      // 주차 종료일
      if (endDt > lastDay) {
        this.endDt = lastDay
      } else {
        this.endDt = endDt
      }

      // 데이터 조회
      this.getUnitMindWeatherReply()
    },
    async getUnitMindWeatherReply() {
      await store.dispatch('getUnitMindWeatherReply', this.$_payload('so', [{'userKey': this.userKey}
        , {'weekYn': this.weekYn}
        , {'startDt': this.startDt}
        , {'endDt': this.endDt}
      ]))
          .then(res => {
            if (res.success) {
              // 배열 초기화
              this.week.splice(0, this.week.length)
              this.scoreArr[0].splice(0, this.scoreArr[0].length)
              this.scoreArr[1].splice(0, this.scoreArr[1].length)
              this.scoreArr[2].splice(0, this.scoreArr[2].length)

              if (this.weekYn === 'Y') { // 주간

                this.week.push('일', '월', '화', '수', '목', '금', '토')

                res.data.forEach((obj, i) => {
                  // console.log('obj : ', obj)
                  // if(obj.replyList != null){
                  //     obj.replyList.forEach((reply) => {
                  //         this.scoreArr[i].push(reply.score)

                  //         if(i == 0){
                  //             this.week.push(reply.dayOfWeek)
                  //         }
                  //     });
                  // }
                  this.week.forEach((week) => {
                    var score = "없음"
                    obj.replyList.forEach((reply) => {
                      if (week === reply.dayOfWeek) {
                        // cmpr = true
                        score = reply.score
                      }
                    })
                    this.scoreArr[i].push(score)
                  })
                });
              }

            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
            // this.answer = [];
          })
          .finally(() => {
          })
    },
    async setMemberResultDel() {
      await store.dispatch('setMemberResultDel', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                if(store.getters.isApplResult === 'success') {
                  this.goTravelPage('RR');
                } else {
                  this.goTravelPage('S');
                }
              }
            } else {
              console.log(res.msg)
              this.pageCnt = 0;
              this.step = 0;
            }
          })
          .catch(error => {
            console.error(error)
            this.pageCnt = 0;
            this.step = 0;
          })
          .finally(() => {
          })
    },
    async getMemberStepCnt() {
      await store.dispatch('getMemberStepCnt', this.$_payload('so', [{'travelApplNo': this.travelApplNo}, {'memberNo': this.userKey}, {'travelApplStepCd': this.travelApplStepCd}]))
          .then(res => {
            if (res.success) {
              this.memberStepApplCnt = res.data;
              this.getProgressStep(res.data);
            } else {
              this.memberStepApplCnt = 1;
              this.goTravelPage('S');
            }
          })
          .catch(error => {
            console.error(error)
            this.memberStepApplCnt = 1;
            this.goTravelPage('S');
          })
          .finally(() => {
            store.commit('setInitApplResult', true)
          })
    },
    async getProgressStep() {
      await store.dispatch('getProgressStep', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'unitNo': 1},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
          .then(res => {
            if (res.success) {

              if (res.data != null) {
                if (10 === res.data.unitDtlSeq) {   // 완료한 여행지원서
                  if(store.getters.isApplResult === 'success') {
                    this.goTravelPage('RR');
                  } else {
                    this.goTravelPage('S');
                  }
                } else {    // 진행중인 여행지원서
                  this.$confirm('작성 중인 여행지원서가 있습니다. <br>이어서 하시겠습니까?', {
                    persistent: false,
                    showClose: true,
                    actions: {
                      false: {text: '새로 작성하기'},
                      true: {text: '이어서 하기', color: '#ff4a4a'}
                    }
                  }).then(result => {
                    if (result === true) { // 이어서 하기
                      if(store.getters.isApplResult === 'success') {
                        this.goTravelPage('RR');
                      } else {
                        this.goTravelPage('S');
                      }
                    } else if (result === false) { // 새로하기
                      this.$confirm('여행지원서를 새로 작성하시면 <br>전에 진행한 여행지원서는 삭제됩니다.', {
                        actions: {
                          false: {text: '취소'},
                          true: {text: '새로 작성하기', color: '#ff4a4a'}
                        }
                      }).then(result => {
                        if (result === true) { // 새로 작성하기
                          this.setMemberResultDel()
                        }
                      })
                    }
                  })
                }
              } else {
                this.goTravelPage('S');
              }
            } else {
              console.log(res.msg)
              this.pageCnt = 0;
              this.step = 0;
            }
          })
          .catch(error => {
            console.error(error)
            this.pageCnt = 0;
            this.step = 0;
          })
          .finally(() => {
          })
    },
    async getUseOrdDtlNoGuide() {  // 유저 티켓 사용 API
      await store.dispatch('getUseOrdDtlNoGuide')
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                this.noGuide = true
              }
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {

          })
    },
    async getCoinAmount() {
      await store.dispatch('coinDetail', this.$_payload({}))
          .then(res => {
            this.amountCoin = res.data.amountCoin + 'C';
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    },
    goCoinPage() {
      this.movePage('/fo/coin');
    },
    // async getUserNickname () {
    //     await store.dispatch('getUserNickname')
    //         .then(res => {
    //         if (res.success) {
    //             this.nickname = res.data;
    //         } else {
    //             console.log(res.msg);
    //             this.nickname = '';
    //         }
    //         })
    //         .catch(error => {
    //         console.error(error);
    //         this.nickname = '';
    //         })
    //         .finally(() => {})
    // },
    async getMappingSolution() { // 솔루션 매핑여부 확인
      await store.dispatch('getMappingSolution')
          .then(res => {
            if (res.success) {
              if (res.data !== null) {
                store.commit('setSolMappingYnSuccess')
              } else {
                store.commit('setSolMappingYnFail')
              }
            } else {
              store.commit('setSolMappingYnFail')
            }
          })
          .catch(() => {
            store.commit('setSolMappingYnFail')
          })
          .finally(() => {
            store.commit('setInitSolMappingYn', false)
          })
    },
    solutionPause() {
      if(this.travelStopYn === 'Y' || this.isPauseReserved){
        this.movePage('/fo/solutionPause');
      }
    }
  }
}
</script>
